<template>
  <div class="mobile headmaster-submission-details">
    <div class="message_date">{{detailsValue.dsCreateTime}}</div>
    <DsfMessagePanel arrowDirection="left">
      <div slot="content" class="message_title">
        <div class="message_user_info">
          <van-image radius="50%" width="48" height="48" fit="cover" :src="detailsValue.photo | imgFormat">
            <template v-slot:error>
              <img :src="defaultImg | imgFormat" alt="" class="err_img">
            </template>
          </van-image>
          <div class="user_info_name">
            <p class="info_name">{{detailsValue.stuName || ''}}</p>
            <span class="info_class">{{detailsValue.className || ''}}</span>
          </div>
        </div>
        <div class="propose_date">提出时间：{{detailsValue.dsCreateTime}}</div>
        <p class="headmaster_title">
          <span>类型：</span>{{detailsValue.typeText}}
        </p>
        <div class="content">{{detailsValue.suggest}}</div>
        <div class="message_img">
          <van-image v-for="(item,index) of imgUrl()" :key="index" radius="5" width="80" height="80" fit="cover" :src="item.relativePath" @click="messageChange(index)">
            <template v-slot:error>
              <img :src="require('../../assets/styles/themes/img/submissionErr_mobile.png')" alt="" class="err_img">
            </template>
          </van-image>
        </div>
      </div>
    </DsfMessagePanel>
    <template v-if="detailsValue.replyStatusValue=='1'">
      <div v-for="(item,index) of detailsValue.suggestReplyList" :key="index">
        <div class="message_date">{{item.dsCreateTime || ''}}</div>
        <DsfMessagePanel arrowDirection="right">
          <div slot="content" class="message_title">
            <div class="reply">
              <span>回复内容：</span>
              {{item.detail}}（{{item.dsCreateUserName}}）
            </div>
          </div>
        </DsfMessagePanel>
      </div>
    </template>
    <div class="message_zw" v-if="!ownReply && detailsValue.id"></div>
    <div class="set_message" v-if="!ownReply && detailsValue.id" @click="toMessageUrl">
      <div class="message_box">
        <span>回复内容：</span>请输入您的回复内容
      </div>
    </div>
    <van-image-preview v-model="showImage" :images="preview" class-name="preview_box" :start-position="startPosition">
    </van-image-preview>
  </div>
</template> 

<script>
import DsfMessagePanel from "./messagePanel.vue";
export default dsf.component({
  name: "DsfMobileHeadmasterSubmissionDetails",
  ctrlCaption: "班主任历史提交详情",
  mixins: [$mixins.control],
  components: {
    DsfMessagePanel,
  },
  data() {
    return {
      detailsValue: [],
      ownReply: false,
      defaultImg: dsf.config.setting_public_user_default_header,
      showImage: false,
      preview: [],
      startPosition: 0,
    };
  },
  methods: {
    // 图片预览+
    messageChange(index) {
      this.startPosition = index;
      this.showImage = true;
      console.log(1);
    },
    imgUrl() {
      if (this.detailsValue.attachment) {
        let imgArr = JSON.parse(this.detailsValue.attachment);
        return imgArr
      } else {
        return []
      }
    },
    // 到消息发送
    toMessageUrl() {
      this.$open({
        url: '#/mobile/teas/classes/suggest/mobile/mobile-messagereplyindex?id=' + this.detailsValue.id,
        state: 1
      })
    },
    getMessageData() {
      let data = {
        id: this.queryString.id || '',
      }
      let that = this;
      this.$http.get('/mobile/classes/suggest/getSuggestDetail', data).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          that.detailsValue = res.data;
          if (this.detailsValue.attachment) {
            let imgArr = JSON.parse(this.detailsValue.attachment);
            this.preview = [];
            imgArr.forEach(element => {
              this.preview.push(element.relativePath)
            });
          }

          this.detailsValue.suggestReplyList.some(element => {
            if (element.ownReply) {
              this.ownReply = true;
              return true
            }
          });
        } else {
          dsf.layer.message(res.message, false);
        }
      })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
    },
  },
  activated() {
    this.getMessageData()
  },
  created() {
    if (this.isDesign) {
      this.detailsValue = {
        attachment: null,
        classId: "f7c8a9d37e1e4086873f216cf548e7da",
        className: "测试请假与评估关联班",
        dsCreateTime: "2022-03-04 10:41",
        dsCreateUserId: "b4e96b5f66b642f9b6c6dc695f68f481",
        dsCreateUserName: "学员01",
        id: "b34b3956bf744a0fa18f2b938f0bddb7",
        photo: "[{\"originalFileName\":\"f18d063759cdf9b7dff6477fffce279b.jpg\",\"suffix\":\"jpg\",\"size\":19422,\"uploadDate\":\"2022-03-02 10:09:40\",\"relativePath\":\"/upload/files/20220302/054b2d2adba141df9f38863e05ec98e4.jpg\",\"name\":\"f18d063759cdf9b7dff6477fffce279b\",\"absolutePath\":\"http://192.168.0.61/upload/files/20220302/054b2d2adba141df9f38863e05ec98e4.jpg\",\"id\":\"123aa8721985468282c7885d020fe33a\",\"contentType\":\"image/jpeg\"}]",
        replyStatusText: "未回复",
        replyStatusValue: "0",
        stuId: "e03c56cbff9641a3bea27e37b42845b0",
        stuName: "学员01",
        suggest: "cvdfsxsdvfcasdcssdcsdf",
        suggestReplyList: [],
        typeText: "其他",
        typeValue: "4"
      }
    } else {
      this.getMessageData()
    }
  }
})
</script>

<style>
</style>